import { useEffect, useState, useMemo } from 'react';
import axios from 'axios';
import api from "../services/axiosInstance";
import { backendPort } from "../components/Fungsiku";
import { useNotification } from './NotifPopup';
import { PageKonten22 } from './Page21_MaintenanceSubAkun';

//MASTER WILAYAH
export function PageKonten21({token}) {
  const [data, setData] = useState([]);
  const [nama, setNama] = useState('');
  const [sortBy, setSortBy] = useState('nama'); // 'kode' | 'nama'
  const [sortDir, setSortDir] = useState('asc'); // asc | desc
  const [showTambah, setShowTambah] = useState(false); // asc | desc
  const [showEdit, setShowEdit] = useState(false);
  const [editData, setEditData] = useState({id: '',nama: ''});
  const [showHapus, setShowHapus] = useState(false);
  const [hapusData, setHapusData] = useState({id: '', nama: ''});
  const { showNotif } = useNotification();
  const [search, setSearch] = useState("ATK");

  //PAGINATION
  const loadData = () => {
    api.get(
      `${backendPort}/api/master/p_akun`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
  .then(res => {
    const sortedData = [...res.data].sort((a, b) =>
    a.akun.localeCompare(b.akun)
    );
    setData(sortedData);}
  )
  .catch(err => console.error(err));
  };

  useEffect(() => {
    loadData();
  }, []);


  const handleTambah = async (e) => {
    try{
      setShowTambah(false);
      e.preventDefault();

      await api.post(`${backendPort}/api/master/tambah_akun`, {
        nama
      });

      setNama('');
      loadData();
      
      showNotif('success', 'Data Berhasil Ditambahkan');  
    } catch (err) {
      showNotif('error', 'Penambahan Data Gagal');
    }
    
  };
  
  const handleEdit = async (e) => {
    try{
      setShowEdit(false);  
      e.preventDefault();
      await api.put(
      `${backendPort}/api/master/edit_akun/${editData.id}`,
      { nama: editData.nama }
      );
      
      showNotif('success', 'Update Data Berhasil');
      loadData();
    }
    catch(e)
    {showNotif('error', 'Update Data Gagal');}
  };
  
  const handleDelete = async (e) => {
    try{
      setShowHapus(false);
      if (e) e.preventDefault();
      
      await api.delete(
      `${backendPort}/api/master/delete_akun/${hapusData.id}`
      );
      
      showNotif('success', 'Delete Data Berhasil');
      loadData();
      
    }
    catch(e)
    {showNotif('error', 'Delete Data Gagal');}
  };

  const handleSort = (field) => {
    if (sortBy === field) {
      setSortDir(sortDir === 'asc' ? 'desc' : 'asc');
    } else {
      setSortBy(field);
      setSortDir('asc');
    }
  };

const sortedData = [...data].sort((a, b) => {
  if (!sortBy) return 0;

    const valA = sortBy === 'kode' ? a.id : a.akun;
    const valB = sortBy === 'kode' ? b.id : b.akun;

    if (sortDir === 'asc') {
      return valA.localeCompare(valB);
    } else {
    return valB.localeCompare(valA);
    }
  });

  return (

    <div className="container-fluid">
      <div className="row">
{/** ===================== AKUN ================================= */}
          <div className="col-md-5">
            <div className="accordion-manual">              
                            {/*LPJ*/}
                            <div className="accordion-item">
                                <div
                                className="accordion-header text-white"
                                >Daftar Akun
                                </div>
                                <div className={`accordion-body open`}>
                                <div className="accordion-content">
                                    {/*KONTEN 2*/}
                                <div className="card-body p-0">
                                <div className="row my-2 mx-1">
                                    <div className="col-md-4">
                                    </div>
                                    <div className="col-md-4"></div>
                                    <div className='flex justify-content-end mx-3'>
                                <button 
                                    className="btn btn-outline-dark ls"  
                                    onClick={()=>{
                                        setShowTambah(!showTambah); 
                                        setShowEdit(false); 
                                        setShowHapus(false); 
                                        setNama('');
                                        }}>Tambah <i className="fa fa-add"></i>
                                </button>
                                </div>
                                </div>
                                <table className="table table-bordered table-hover">
                                    <thead className="bg-info">
                                    <tr>
                                        <th onClick={() => handleSort('kode')} style={{ cursor: 'pointer' }}>
                                        <div className="d-flex justify-content-between align-items-center">
                                            <span>Kode</span>
                                            {sortBy === 'kode' && (
                                            <span>{sortDir === 'asc' ? '▲' : '▼'}</span>
                                            )}
                                        </div>
                                        </th>

                                        <th onClick={() => handleSort('nama')} style={{ cursor: 'pointer' }}>
                                        <div className="d-flex justify-content-between align-items-center">
                                            <span>Nama Akun</span>
                                            {sortBy === 'nama' && (
                                            <span>{sortDir === 'asc' ? '▲' : '▼'}</span>
                                            )}
                                        </div>
                                        </th>
                                        
                                        <th width="80">Aksi</th>
                                    
                                    </tr>
                                    </thead>
                                    <tbody>
                                        {sortedData.map((row) => (
                                        <tr key={row.id}>
                                            <td>{`PA-${row.id}`}</td>
                                            <td className='text-primary fw-bold'
                                              onClick ={()=>setSearch(row.akun)}
                                              style = {{cursor : 'pointer'}}
                                              >{row.akun}</td>
                                            <td className="d-flex justify-content-between align-items-center">
                                            <span onClick={async () => {
                                                console.log(row);
                                                setEditData({id: row.id, nama: row.akun});
                                                setShowEdit(!showEdit);
                                                setShowTambah(false);
                                                setShowHapus(false);
                                                }}
                                                style={{ cursor: 'pointer' }}>
                                                <i className="fa fa-solid fa-edit"></i>
                                                </span>

                                            <span onClick={() => {
                                                console.log(row);
                                                setHapusData({id: row.id, nama: row.akun});
                                                setShowHapus(!showHapus);
                                                setShowTambah(false);
                                                setShowEdit(false);
                                                }}
                                                style={{ cursor: 'pointer' }}>
                                                <i className="fa fa-trash text-red-500"></i>
                                                </span>
                                            </td>
                                        </tr>
                                        ))}
                                    </tbody>
                                </table>
                                </div>
                                
    
                                    </div>
                                </div>
                              </div>  
               </div>
          </div>
{/** ===================== SUBAKUN ================================= */}        
        <div className="col-md-7">
          <PageKonten22 token = {token} search = {search}/>
        </div>
      

        {/* FORM TAMBAH*/}
        {showTambah && <div
          className="modal fade show"
          style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.3)' }}
        ><div className="modal-dialog modal-dialog-centered">
        <div className="col-md-6 modal-content">
          <div className="card">
            <div className="card-header" style={{ background: "#09314F", color: "#fff" }}>
              Tambah Akun
            </div>
            <div className="card-body">
              <form>
                <div className="mb-3">
                  <label>Nama Akun Baru</label>
                  <input
                    className="form-control"
                    value={nama}
                    onChange={(e) => setNama(e.target.value)}
                  />
                </div>

                <button className="btn btn-primary me-2"
                  disabled={!nama.trim()}
                  onClick={handleTambah}
                  >Simpan</button>
                <button
                  type="button"
                  className="btn btn-success"
                  onClick={() => {
                    setNama('');
                    setShowTambah(false);
                  }}
                >
                  Batal
                </button>
              </form>
            </div>
          </div>
        </div></div></div>}

        {/* FORM Edit*/}
        {showEdit && <div
          className="modal fade show"
          style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.3)' }}
        ><div className="modal-dialog modal-dialog-centered">
        <div className="col-md-6 modal-content">
          <div className="card">
            <div className="card-header" style={{ background: "#09314F", color: "#fff" }}>
              Edit Nama Akun
            </div>
            <div className="card-body">
              <form onSubmit={handleEdit}>
                <div className="mb-3">
                  <label>Kode</label>
                  <input
                    className="form-control"
                    value={`PA-${editData.id}`}
                    disabled
                  />
                </div>
                
                <div className="mb-3">
                  <label>Nama Akun</label>
                  <input
                    className="form-control"
                    value={editData.nama}
                    onChange={(e) => setEditData({ ...editData, nama: e.target.value })}
                  />
                </div>

                <button className="btn btn-primary me-2">Update</button>
  
                <button
                  type="button"
                  className="btn btn-success"
                  onClick={() => {
                    setNama('');
                    setShowEdit(false);
                  }}
                > Batal</button>
              </form>
            </div>
          </div>
        </div></div></div>
        }

        {/* FORM Hapus*/}
        {showHapus && 
        
        <div
          className="modal fade show"
          style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.3)' }}
        ><div className="modal-dialog modal-dialog-centered">
        <div className="col-md-6 modal-content">
        
          <div className="card">
            <div className="card-header" style={{ background: "#dc3545", color: "#fff" }}>
              Hapus Akun
            </div>
            <div className="card-body">
              <form>
                <div className="mb-3">
                  <label>Kode</label>
                  <input
                    className="form-control"
                    value={`PA-${hapusData.id}`}
                    disabled
                  />
                </div>
                
                <div className="mb-3">
                  <label>Nama Akun</label>
                  <input
                    className="form-control"
                    value={hapusData.nama}
                    disabled
                  />
                  <label className='fs-6 fst-italic'>Pastikan akun yang dihapus tidak memiliki sub akun</label>
                </div>

                <button className="btn btn-danger me-2" 
                    onClick={handleDelete}
                    >Delete</button>
  
                <button
                  type="button"
                  className="btn btn-success"
                  onClick={() => {
                    setNama('');
                    setShowHapus(false);
                  }}
                > Batal</button>
              </form>
            </div>
          </div>
        </div></div></div>}

      </div>
    </div>
  );
}
